import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function LogrosSection() {
  const logros = [{
    text: <>
          Tener tu{' '}
          <strong className="text-[#000000] font-semibold" data-id="element-330">
            tienda digital activa y lista para vender
          </strong>{' '}
          en horas, aunque hoy no sepas nada de venta por internet.
        </>
  }, {
    text: <>
          Subir tu ebook y{' '}
          <strong className="text-[#000000] font-semibold" data-id="element-331">
            automatizar la entrega al comprador
          </strong>{' '}
          sin depender de nadie más.
        </>
  }, {
    text: <>
          Dejar de improvisar y usar una{' '}
          <strong className="text-[#000000] font-semibold" data-id="element-332">
            estructura probada que vende
          </strong>
          .
        </>
  }, {
    text: <>
          <strong className="text-[#000000] font-semibold" data-id="element-333">
            Evitar errores que te hacen perder ventas
          </strong>
          , como tener una página desordenada o cobrar mal.
        </>
  }, {
    text: <>
          Lanzar sin miedo ni dudas, con una checklist que{' '}
          <strong className="text-[#000000] font-semibold" data-id="element-334">
            te guía paso a paso
          </strong>
          .
        </>
  }, {
    text: <>
          <strong className="text-[#000000] font-semibold" data-id="element-335">
            Vender tu ebook en piloto automático
          </strong>
          : la tienda trabaja por vos mientras vos hacés lo que amás.
        </>
  }];
  return <section className="w-full bg-white pt-8 md:pt-12 pb-10 md:pb-14 px-6" data-id="element-336">
      <div className="max-w-4xl mx-auto" data-id="element-337">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-338">
          <div className="relative text-center mb-10 md:mb-14" data-id="element-339">
            <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#000000]/[0.05] rounded-full blur-[120px] pointer-events-none" data-id="element-340" />
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10" data-id="element-341">
              ¿Tenés dudas sobre qué vas a
              <br data-id="element-342" />
              <span className="text-[#000000]" data-id="element-343">aprender</span> dentro de{' '}
              <span className="text-[#000000]" data-id="element-344">Emprende Digital</span>?
              <br data-id="element-345" />
              <span className="text-2xl md:text-3xl font-bold text-gray-600" data-id="element-346">
                Te dejamos todo el detalle
              </span>
            </h2>
          </div>

          <div className="flex flex-col gap-4 max-w-3xl mx-auto" data-id="element-347">
            {logros.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="flex items-center gap-4 p-5 md:p-6 rounded-2xl border border-gray-300/60 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-348">
                <div className="w-7 h-7 rounded-full bg-[#000000] flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-349">
                  <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-350" />
                </div>
                <p className="text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-351">
                  {item.text}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}